import { type FC } from 'react';
import * as React from 'react';

import Upload from '@/components/Icons/Upload';

import Button from '../DesignLibrary/Button';

type Props = {
  onClick: () => void;
};

const UploadAudioButton: FC<Props> = ({ onClick }) => (
  <Button variant='primary' size='md' onClick={onClick} fullWidth>
    <Upload size={16} style={{ marginRight: 8 }} /> Upload Audio
  </Button>
);

export default UploadAudioButton;
